import React from 'react';
import styled, { css } from 'styled-components';
import { formatUserMessage } from '../common';
import { techColors, neonGlow, terminalBorder, terminalTextStyle } from './TechRetroEffects';

/** success: true → green, false → red, undefined → neutral white */
export const getStatusMessageColor = (success) => {
  if (success === true) {
    return techColors.success;
  }
  if (success === false) {
    return techColors.danger;
  }
  return techColors.textPrimary;
};

export const statusMessageAppearance = css`
  color: ${({ success }) => getStatusMessageColor(success)};
  background-color: ${techColors.darkBgSecondary};
  ${({ success }) => terminalBorder(getStatusMessageColor(success))}
  ${({ success }) => neonGlow(
    getStatusMessageColor(success),
    success === false ? 'normal' : 'subtle',
  )}
  ${terminalTextStyle}
`;

const formatStatusChildren = (children) => {
  if (typeof children === 'string' || typeof children === 'number') {
    return formatUserMessage(children);
  }
  return children;
};

const AuthPageMessageBox = styled.p.withConfig({
  shouldForwardProp: (prop) => prop !== 'success',
})`
  position: absolute;
  top: 20px;
  width: 100%;
  max-width: 400px;
  font-weight: 400;
  padding: 12px 16px;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 15px;
  font-size: 0.9em;
  ${statusMessageAppearance}

  @media (max-width: 480px) {
    top: 10px;
    max-width: 90%;
    font-size: 0.85em;
    padding: 10px 14px;
  }
`;

export const AuthPageMessage = ({ success, children, ...props }) => (
  <AuthPageMessageBox success={success} {...props}>
    {formatStatusChildren(children)}
  </AuthPageMessageBox>
);

const FormStatusMessageBox = styled.p.withConfig({
  shouldForwardProp: (prop) => prop !== 'success',
})`
  width: 100%;
  max-width: 100%;
  margin: 0;
  min-height: 36px;
  ${statusMessageAppearance}
  font-size: 11px;
  border-radius: 4px;
  padding: 6px 10px;
  max-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  overflow: hidden;
  box-sizing: border-box;
  visibility: ${({ children }) => (children && String(children).trim() ? 'visible' : 'hidden')};
  opacity: ${({ children }) => (children && String(children).trim() ? 1 : 0)};
  transition: opacity 0.3s ease-out, visibility 0.3s ease-out;
`;

export const FormStatusMessage = ({ success, children, ...props }) => (
  <FormStatusMessageBox success={success} {...props}>
    {formatStatusChildren(children)}
  </FormStatusMessageBox>
);
